import store from "store";
export var EStoreEpAlertKey;
(function (EStoreEpAlertKey) {
    EStoreEpAlertKey["POST_MEDIA_NOTICE"] = "post_media_notice";
    EStoreEpAlertKey["POST_CREATE_SUBSCRIPTION"] = "post_create_subscription";
    EStoreEpAlertKey["POST_CREATE_ATTACHMENTS_PLACE_WARNING"] = "post_create_attachments_place_warning";
    EStoreEpAlertKey["POST_ORGANIZATION_MODE_ALERT"] = "post_organization_mode_alert";
    EStoreEpAlertKey["PC_SCHEDULE_CONFIRMATION"] = "pc_schedule_confirmation";
    EStoreEpAlertKey["PC_SCHEDULE_CONFIRMATION_NOW"] = "pc_schedule_confirmation_now";
})(EStoreEpAlertKey || (EStoreEpAlertKey = {}));
export const storeEp = {
    get: (key) => {
        const value = store.get("ep", {})[key];
        return value !== undefined ? value : null;
    },
    set: (key, value) => {
        store.set("ep", Object.assign(Object.assign({}, store.get("ep", {})), { [key]: value }));
    },
};
export const storeEpProjects = {
    get: (key) => {
        const projects = storeEp.get("projects");
        return projects && projects[key] !== undefined ? projects[key] : null;
    },
    set: (key, value) => {
        const projects = storeEp.get("projects") || {};
        storeEp.set("projects", Object.assign(Object.assign({}, projects), { [key]: value }));
    },
};
export const storeEpAlerts = {
    get: (key) => {
        const alerts = storeEp.get("alerts");
        return alerts && alerts[key] !== undefined ? alerts[key] : null;
    },
    set: (key, value) => {
        const alerts = storeEp.get("alerts") || {};
        storeEp.set("alerts", Object.assign(Object.assign({}, alerts), { [key]: value }));
    },
};
//# sourceMappingURL=store.js.map